export const ASPECT_RATIO_TYPES = {
  LANDSCAPE: 'landscape',
  PORTRAIT: 'portrait',
};

export const ACCEPTED_IMAGE_TYPES = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/webp',
];
